import { createSelector } from '@reduxjs/toolkit';
import { TagsState } from './index';

export const selectTags = createSelector([(state: { tags: TagsState }) => state.tags?.tags ?? []], (items) => items);
export const selectGetTagsStatus = (state: { tags: TagsState }) => state.tags?.getTagsStatus;
export const selectGetTagsErrorInfo = (state: { tags: TagsState }) => state.tags.getTagsError;
export const selectDeleteTagStatus = (state: { tags: TagsState }) => state.tags.deleteTagStatus;
export const selectDeleteTagErrorInfo = (state: { tags: TagsState }) => state.tags.deleteTagError;
